export const ReportFilterType = {
  INTEGER: 'INTEGER',
  DECIMAL: 'DECIMAL',
  TEXT: 'TEXT',
  BOOLEAN: 'BOOLEAN',
  DATE: 'DATE',
  ID: 'ID',
  BAN: 'BAN',
  PHONE: 'PHONE',
};

export const screenStep = {
  MAIN: 'MAIN',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};
